import React from 'react';
import ContentBuilder from '../../core/ContentBuilder';
import styles from './PrizeList.module.scss';

export class PrizeList extends React.Component
{
  render()
  {
    console.log(this.props);
    return (
      <div className={styles['container']}>
        { this.props['children'] }
      </div>
    )
  }
}